(() => {
  if (customElements.get('tfdawn-wishlist')) return;
  class SavedHair extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.version = 0;
      this.key = 'shopify-wishlist';
      this.strings = JSON.parse(this.querySelector('[data-wish-strings]').textContent);
      this.status = this.querySelector('[data-wish-status]');
      this.list = this.querySelector('[data-wish-list]');
      this.root = this.dataset.root || '/';
      this.onClick = event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-wish-add')) {
          const handle = this.querySelector('[data-wish-product]').value;
          if (!handle) return;
          try { const saved = this.records(); if (!saved.includes(handle)) saved.push(handle); this.save(saved); } catch { this.status.textContent = this.strings.storageError; return; }
          this.load();
        } else if (button.dataset.remove) {
          try { this.save(this.records().filter(h => h !== button.dataset.remove)); } catch { this.status.textContent = this.strings.storageError; return; }
          this.load();
        } else if (button.hasAttribute('data-wish-retry')) this.load();
      };
      this.onStorage = event => { if (event.key === this.key || event.key === null) this.load(); };
      this.addEventListener('click', this.onClick);
      window.addEventListener('storage', this.onStorage);
      this.load();
    }
    disconnectedCallback() { this.version++; this.removeEventListener('click', this.onClick); window.removeEventListener('storage', this.onStorage); this.ready = false; }
    records() { return (localStorage.getItem(this.key) || '').split(',').filter(Boolean); }
    save(records) { if (records.length) localStorage.setItem(this.key, records.join(',')); else localStorage.removeItem(this.key); }
    node(tag, text) { const el = document.createElement(tag); if (text != null) el.textContent = text; return el; }
    async load() {
      const version = ++this.version;
      let records;
      try { records = [...new Set(this.records())]; } catch { this.status.textContent = this.strings.storageError; return; }
      this.status.textContent = records.length ? this.strings.loading : this.strings.empty;
      this.list.replaceChildren();
      const rows = await Promise.all(records.map(async handle => {
        if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return { handle, invalid: true };
        try {
          const response = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
          if (response.status === 404) return { handle, unavailable: true };
          if (!response.ok) throw Error('Product request failed');
          return { handle, product: await response.json() };
        } catch { return { handle, failed: true }; }
      }));
      if (version !== this.version || !this.isConnected) return;
      if (records.length) this.status.textContent = '';
      for (const row of rows) {
        const card = this.node('article');
        if (row.product) {
          const p = row.product, url = this.root + 'products/' + encodeURIComponent(row.handle);
          if (p.featured_image) {
            try { const imageUrl = new URL(p.featured_image, location.origin); if (['https:', 'http:'].includes(imageUrl.protocol)) {
              const img = this.node('img'); img.src = imageUrl.href; img.alt = p.title || row.handle; img.width = 600; img.height = 800; img.loading = 'lazy'; card.append(img);
            } } catch {}
          }
          const title = this.node('h2'), link = this.node('a', p.title || row.handle); link.href = url; title.append(link); card.append(title);
          const amount = Number(p.price_min ?? p.price);
          if (Number.isFinite(amount)) {
            let formatted;
            try { formatted = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(amount / 100); } catch { formatted = (amount / 100).toFixed(2); }
            card.append(this.node('p', formatted));
          }
          const choose = this.node('a', this.strings.select); choose.href = url; card.append(choose);
        } else {
          card.append(this.node('h2', row.handle), this.node('p', row.failed ? this.strings.error : this.strings.unavailable));
          if (row.failed) { const retry = this.node('button', this.strings.retry); retry.type = 'button'; retry.setAttribute('data-wish-retry', ''); card.append(retry); }
        }
        const remove = this.node('button', this.strings.remove); remove.type = 'button'; remove.dataset.remove = row.handle; remove.setAttribute('aria-label', this.strings.remove + ': ' + (row.product?.title || row.handle)); const actions = this.node('div'); actions.append(remove); card.append(actions);
        this.list.append(card);
      }
    }
  }
  customElements.define('tfdawn-wishlist', SavedHair);
})();
